/* eslint-disable no-useless-catch */

import { serialize } from '../utils';
import { entityService } from './services';
// #endregion Local Imports

const pathname = '/admin/entity-product-contact-requests';

export const EntityContactRequestApi = {
  filter: async (option: any) => {
    let url = `${pathname}/filter`;

    const { entityIDs, ...newOption } = option;
    const query = serialize(newOption);
    url += query;

    try {
      const response = await entityService.post(url, { entityIDs });

      return response;
    } catch (error) {
      throw error;
    }
  },

  updateStatus: async (id: string, body: any = {}) => {
    const url = `${pathname}/${id}/status`;

    try {
      const response = await entityService.patch(url, body);
      return response;
    } catch (error) {
      throw error;
    }
  },

  delete: async (id: string) => {
    const url = `${pathname}/${id}`;

    try {
      const response = await entityService.delete(url);
      return response;
    } catch (error) {
      throw error;
    }
  },
};
